<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/insular-header-pt.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/madeira-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para a Madeira</p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Serviço de entrega prevista desde 1 dia útil seguinte ao da sua recolha (via aérea: peso máximo por volume 20Kg) e também disponível desde 5 dias úteis seguintes à sua recolha (via marítima: peso máximo por volume 30 Kg).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/acores-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para os Açores</p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Serviço de entrega prevista desde 2 dias úteis seguintes ao da sua recolha (via aérea: peso máximo por volume 5Kg) e também disponível desde 6 dias úteis seguintes à sua recolha (via marítima: peso máximo por volume 30 Kg).
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttbaleares-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para as Baleares</p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b>  Serviço de entrega prevista desde 1 dia útil após a sua recolha (via aérea), e também disponível a partir de 2 dias úteis seguintes à sua recolha (via marítima). Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttcanarias-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para as Canárias</p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Serviço de entrega prevista desde 2 dias úteis após a sua recolha. Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttotherdest-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para outros Destinos</p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Serviço de entrega prevista desde 2 dias úteis após a sua recolha (via aérea). Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt-nexus/Footer'

export default {
  name: 'InsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularIntro')
  },
}
</script>
